import * as React from 'react';
import {  AccordionDetails, AccordionSummary, Box, Button, Divider, Skeleton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CustomAccordion } from "./style";
import { formatPrice } from '../../../shared/utils';
import { useEffect, useState } from 'react';
import { PurchaseSummary, SummaryItems } from 'src/app/react/models/purchase/summary-purchase.model';
import { useAppDispatch, useAppSelector } from 'src/app/react/hooks/redux';
import { Auth } from 'src/app/models/auth';
import { getPurchaseSummary } from 'src/app/react/redux/purchase/actions';
interface SummaryPurchaseProps {
  products: number[],
  handleSummaryCalculation: () => void
}

export const SummaryPurchase = ({ products, handleSummaryCalculation }: SummaryPurchaseProps) => {
    
    const currentUser: Auth = JSON.parse(localStorage.getItem('currentUser'));
    
    const dispatch = useAppDispatch();

    const [ expandedProduct, setExpandedProduct ] = useState<number | false>(false);
    const { purchase, summary, summaryLoading } = useAppSelector(state => state.purchase);
    const { loading: collaboratorsLoading } = useAppSelector(state => state.collaborator);

    useEffect(() => {
      dispatch(getPurchaseSummary(currentUser.token.assignorGuid, currentUser.token.userReferenceId, purchase, products[0], 0, 0, {}))
    }, [])

    const handleChangeAccordion = (panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedProduct(isExpanded ? panel : false);
    };

  

    return (
        <Box sx={{width: '100%', height: '100%', backgroundColor: '#f6f6f6', padding: '0.5rem'}}>
          <Typography variant="h5">Resumo da Recarga</Typography>
              <Typography variant="h6" mt={2}>Produtos Selecionados: {products.length}</Typography>

              {summary?.summaryItens?.map((item: SummaryItems, index: any) => (
                <CustomAccordion expanded={expandedProduct === item.productId} onChange={handleChangeAccordion(item.productId)} key={item.productId+index}> 
                  <AccordionSummary
                    key={index}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={index+'content'}
                    id={index+'header'}
                    className="p-0"
                  >
                    {summaryLoading ? <Skeleton width={100} height={30} sx={{display: 'inline-block'}}/> :
                      <Typography sx={{fontWeight: '500'}}>                          
                              {item.productName}{expandedProduct != item.productId ? ': '+formatPrice(item.value) : null}                          
                      </Typography>
                    }
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      Colaboradores: {summaryLoading ? <Skeleton width={85} sx={{display: 'inline-block'}}/> : item.total}
                      <br></br>
                      Taxa do Produto: {summaryLoading ? <Skeleton width={85} sx={{display: 'inline-block'}}/> : (item.isPercentage ? item.fee + '%' : formatPrice(item.fee) + '/colaborador')}
                      <br></br>
                      Subtotal: {summaryLoading ? <Skeleton width={85} sx={{display: 'inline-block'}}/> : formatPrice(item.value)}
                    </Typography>                
                  </AccordionDetails>
                </CustomAccordion>
              ))
            }           
            <Divider />
            <Typography variant="h6" mt={2} sx={{fontSize: '1rem'}}>
              Subtotal: {summaryLoading ? <Skeleton width={85} sx={{display: 'inline-block'}}/> : formatPrice(summary?.subTotal)}
              <br></br>
              Valor taxa: {summaryLoading ? <Skeleton width={85} sx={{display: 'inline-block'}}/> : formatPrice(summary?.totalFee)}
              <br></br>
              Total a Pagar: {summaryLoading ? <Skeleton width={85} sx={{display: 'inline-block'}}/> : formatPrice(summary?.total)}
            </Typography>
            <Box sx={{textAlign: 'center'}} className="my-5">
              <Button 
                variant="contained" 
                size="large" 
                sx={{width: '70%'}}
                onClick={handleSummaryCalculation}
                disabled={collaboratorsLoading || summaryLoading}
              >
                Calcular Valores
              </Button>
            </Box>
          </Box>
    );
}
